<script>
    import CartsCollection from '../components/carts/CartsCollection.vue';

    export default {
      components: { CartsCollection },
    };
</script>